import { avgImpressionRatePerPostConfig } from './../avgImpressionRatePerPost';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerImpressionsRateConfig = {
    ...avgImpressionRatePerPostConfig,
    id: 'impression_rate',
    size: SIZE_50,
    name: 'kpi.linkedin.mediaviewer.impressions_rate',
    tooltip: null,
    loader: MediaViewerKpiLoader
};
